var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { sm12: "", md12: "" } },
    [
      !_vm.showReservation
        ? _c(
            "v-layout",
            {
              staticStyle: { "padding-right": "10px" },
              attrs: {
                row: "",
                wrap: "",
                "justify-space-between": "",
                "mt-4": "",
                "mb-5": ""
              }
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("h2", { staticClass: "h2_title mb-1" }, [
                    _vm._v(
                      "\n        Detalle de Equipos, Periféricos y Servicios\n      "
                    )
                  ]),
                  _c("v-divider")
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", md4: "" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "Buscar...", "append-icon": "search" },
                    on: { input: _vm.handleSearch },
                    model: {
                      value: _vm.quickSearch,
                      callback: function($$v) {
                        _vm.quickSearch = $$v
                      },
                      expression: "quickSearch"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                {
                  staticStyle: { "padding-right": "0px" },
                  attrs: { xs12: "", sm6: "", md4: "" }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "padding-top": "6px",
                        "padding-right": "0px"
                      },
                      attrs: { align: "right" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticStyle: { "padding-right": "20px" },
                          attrs: { color: "#ffe800" },
                          on: { click: _vm.handleOpen }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: { color: "black" },
                              attrs: { dark: "", left: "" }
                            },
                            [_vm._v("add_circle_outline")]
                          ),
                          _c("span", { staticStyle: { color: "black" } }, [
                            _vm._v("Reservar Equipos")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "" } },
                [
                  _c("GridComponent", {
                    staticClass: "ag-theme-material",
                    attrs: { "grid-options": _vm.gridOptions }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.showReservation
        ? _c("TabProductsReservation", {
            attrs: { data: _vm.data, ndv: _vm.ndv, ndvnumero: _vm.ndvnumero },
            on: { cerrar: _vm.handleCancel }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }